import Vue from 'vue';

Vue.directive('shadow', function (el, binding, node) {
  const modifiers = binding.modifiers;
  const classes = Object.keys(modifiers).map(key => `has-shadow-${key}`);
  el.classList.add(...classes);
});



// WEBPACK FOOTER //
// ./src/directives/style/v-shadow.js